// v5.7: removido o `history.scrollRestoration = 'manual'` + `scrollTo(0, 0)`.
// Ele mandava o cliente para o topo em TODO carregamento — inclusive ao voltar
// de um produto — e obrigava a passar de novo pelas seções fixadas da home.
// As seções com efeito de scroll já sabem abrir no meio da página.

document.addEventListener('DOMContentLoaded', function () {
  // ---- Nav drawer (abrir/fechar) ----
  var navDrawer = document.getElementById('navDrawer');
  var burgerBtn = document.getElementById('burgerBtn');
  var navDrawerClose = document.getElementById('navDrawerClose');
  var navDrawerOverlay = document.getElementById('navDrawerOverlay');

  function openDrawer() { if (navDrawer) navDrawer.classList.add('is-open'); }
  function closeDrawer() { if (navDrawer) navDrawer.classList.remove('is-open'); }

  if (burgerBtn) burgerBtn.addEventListener('click', openDrawer);
  if (navDrawerClose) navDrawerClose.addEventListener('click', closeDrawer);
  if (navDrawerOverlay) navDrawerOverlay.addEventListener('click', closeDrawer);
  if (navDrawer) {
    navDrawer.querySelectorAll('.nav-drawer__links a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
  }

  // ---- Sticky header: esconde ao descer, aparece ao subir ----
  var header = document.getElementById('siteHeader');
  if (header) {
    var lastScroll = window.scrollY;
    var ticking = false;
    function onHeaderScroll() {
      var current = window.scrollY;
      header.classList.toggle('is-scrolled', current > 30);
      if (current > lastScroll && current > 140) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastScroll = current;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onHeaderScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- Logo: na home sobe pro topo; em outras páginas, navega pra home ----
  var logoLink = document.querySelector('.logo');
  if (logoLink) {
    logoLink.addEventListener('click', function (e) {
      var rootUrl = (window.themeRoutes && window.themeRoutes.root_url) || '/';
      var isHomePage = window.location.pathname === rootUrl || window.location.pathname === rootUrl.replace(/\/$/, '');
      if (isHomePage) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      // se não estiver na home, deixa o link seguir normalmente (navega pra home)
    });
  }

  // ---- Reveal on scroll ----
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          ro.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  // ---- Accordion (genérico: FAQ, comparativo, etc.) ----
  function wireAccordion(headSelector, itemSelector, panelSelector) {
    document.querySelectorAll(headSelector).forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest(itemSelector);
        var panel = item.querySelector(panelSelector);
        var isOpen = item.classList.contains('is-open');
        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          item.classList.remove('is-open');
          panel.style.maxHeight = null;
        }
      });
    });
  }
  window.wireAccordion = wireAccordion;
  wireAccordion('.faq-head', '.faq-item', '.faq-panel');
});
